<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex"
import Loader from "@/components/widgets/preloader";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select"

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Input Items",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Input Items",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Input Items",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      nameError: "",
      unitError: "",
      minQtyError: "",
      priceError: "",

      // Value from user input for adding category
      data: {
        is_product: 1,
        name: "",
        unit: "Units",
        quantity: 0,
        buying_price: "",
        minimum_quantity: 0,
        is_final_product: 0,
        is_brand: 0,
        is_base: 0,
        service_for: "",
        service_rate: 0,
        is_additive: "0",
      },
      // edit unit
      editdata: {
        is_product: 1,
        is_final_product: 0,
        is_brand: 0,
        is_base: 0,
        service_for: "",
        service_rate: 0,
        name: "",
        unit: "",
        buying_price: 0,
        minimum_quantity: 0,
        is_additive: "0",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
      Products: []
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("products", ["Units"]),
    ...mapGetters("consumables", ["SaveStatus", "Consumables"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "buying_price",
          sortable: true,
          label: "COST PRICE",
        },
        {
          key: "final_product",
          sortable: true,
          label: "IS FINAL PRODUCT",
        },
        {
          key: "brand",
          sortable: true,
          label: "IS BRAND",
        },
        {
          key: "base",
          sortable: true,
          label: "IS BASE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "addedOn",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ]
      if (this.GeneralSettings && this.GeneralSettings.use_consumable_additives == 1) {
        baseFields.splice(7, 0,
          {
            key: "is_additive",
            sortable: true,
            label: "IS ADDITIVE",
          }
        );
      }      
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.Consumables ? this.Consumables.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Consumables ? this.Consumables.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          this.resetError();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    Consumables(newValue) {
      if (newValue == true) {
        let Pdts = this.Consumables.filter((item) => {
          return item.is_final_product == 1;
        });
        this.Products = Pdts;
      }
    }
  },
  methods: {
    ...mapActions({
      AddItem: "consumables/addConsumables",
      EditItem: "consumables/editConsumables",
      DeleteConsumables: "consumables/deleteConsumables",
      FetchUnits: "products/fetchUnits",
      FetchConsumables: "consumables/fetchConsumables",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    commaSeparator() {
      this.data.buying_price = this.thousandSeperator(this.data.buying_price);
      this.editdata.buying_price = this.thousandSeperator(this.editdata.buying_price);
    },

    checkData() {
      if (this.data.name != "" && this.data.unit != '') {
        let Cons = this.Consumables.filter((item) => {
          return item.phone == parseInt(this.data.unit);
        })
        let ConsCount = Cons.length;
        if (ConsCount > 0) {
          this.nameError = "This consumable in units " + this.data.unit + "  already Exists";
        }
      }

    },
    checkEditData() {
      if (this.editdata.name != "" && this.editdata.unit != '') {
        let Cons = this.Consumables.filter((item) => {
          return item.phone == parseInt(this.editdata.unit);
        })
        let ConsCount = Cons.length;
        if (ConsCount > 0) {
          this.nameError = "This consumable in units " + this.editdata.unit + "  already Exists";
        }
      }

    },

    addItem(modalId) {
      this.modal_id = modalId;

      if (this.data.name == "") {
        this.nameError = "Item name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Item units field is required";
        return;
      } else {
        this.unitError = "";
      }
      if (this.data.buying_price == "") {
        this.priceError = "Cost price field is required";
        return;
      } else {
        this.priceError = "";
      }
      this.checkData()
      if (this.nameError != "") {
        return this.nameError;
      } else {
        this.nameError = "";
      }
      this.AddItem(this.data);
    },
    editItem(modalId) {
      this.modal_id = modalId;

      if (this.editdata.name === "") {
        this.nameError = "Item name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.unit === "") {
        this.unitError = "Item units field is required";
        return;
      } else {
        this.unitError = "";
      }
      if (this.editdata.minimum_quantity === "") {
        this.minQtyError = "Minimum quantity is required";
        return;
      } else {
        this.minQtyError = "";
      }
      if (this.editdata.buying_price === "") {
        this.priceError = "Cost price field is required";
        return;
      } else {
        this.priceError = "";
      }
      this.checkEditData()
      if (this.nameError != "") {
        return this.nameError;
      } else {
        this.nameError = "";
      }
      this.data.id =
        this.EditItem(this.editdata);
    },

    resetAdd() {
      this.data.name = "";
      this.data.unit = "Units";
      this.data.quantity = "0";
      this.data.minimum_quantity = 0;
      this.data.buying_price = "";
      this.data.is_final_product = 0;
      this.data.is_brand = 0;
      this.data.is_base = 0;
      this.data.service_for = "";
      this.data.service_rate = 0;
      this.data.is_additive = "0";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.is_product = 1;
      this.editdata.is_final_product = 0;
      this.editdata.is_brand = 0;
      this.editdata.name = "";
      this.editdata.unit = "";
      this.editdata.minimum_quantity = 0;
      this.editdata.buying_price = "";
      this.editdata.is_base = 0;
      this.editdata.service_rate = 0;
      this.editdata.service_for = "";
      this.editdata.is_additive = "0";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.is_product = data.item.is_product;
      this.editdata.is_final_product = data.item.is_final_product=='Yes'?1:0;
      this.editdata.is_brand = data.item.is_brand=='Yes'?1:0;
      this.editdata.is_base = data.item.is_base;
      this.editdata.service_for = data.item.service_for;
      this.editdata.service_rate = data.item.service_rate;
      this.editdata.name = data.item.name;
      this.editdata.unit = data.item.unit.id;
      this.editdata.buying_price = data.item.buying_price;
      this.editdata.minimum_quantity = data.item.minimum_quantity;
      this.editdata.is_additive = data.item.is_additive;
      this.editdata.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    deleteConsumables(modalId) {
      this.modal_id = modalId;
      this.DeleteConsumables(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    redirect(value) {
      this.$router.push(
        `/consumables/movement/${btoa(value)}`
      );
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SetProducts() {
      if (this.Consumables) {
        let Pdts = this.Consumables.filter((item) => {
          return item.is_final_product == 1;
        });
        this.Products = Pdts;
      }
    }
  },

  created() {
    this.FetchUnits();
    this.SetProducts();
    this.FetchConsumables();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Consumable Items</h4>
              </div>
              <div v-if="MyUserPerm.add_consumable_items == 1" class="col-md-3" align="right">
                <b-button v-b-modal.add-item-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="Consumables ? Consumables : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(base)="data">
                  {{ data.item.is_base == 1 ? 'Yes' : 'No' }}
                </template>
                <template #cell(buying_price)="data">
                  {{ data.item.buying_price ? data.item.buying_price.toLocaleString() : 0 }}
                </template>
                <template #cell(is_additive)="data">
                  {{ data.item.is_additive == 1 ? 'Yes' : 'No' }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button v-if="MyUserPerm.edit_consumables == 1" size="sm" variant="primary"
                      v-b-modal.edit-item-modal @click="showEditModal(data)"><i class="fa fa-edit"></i> Edit</b-button>
                    <b-button size="sm" variant="success" @click="redirect(data.item.id)"><i class="fa fa-retweet"></i>
                      Movements</b-button>
                    <b-button v-if="MyUserPerm.delete_consumables == 1" size="sm" variant="danger"
                      v-b-modal.delete-item-modal @click="showDeleteModal(data)"><i class="fa fa-trash"></i>
                      Delete</b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Loader v-if="!Consumables" />
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-item-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add New Item </template>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a Product</label>
          <div class="input-group">
            <select v-model="data.is_product" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a final Product</label>
          <div class="input-group">
            <select v-model="data.is_final_product" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a Brand</label>
          <div class="input-group">
            <select v-model="data.is_brand" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a Base Product</label>
          <div class="input-group">
            <select v-model="data.is_base" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group mb-3" v-if="data.is_product == 0">
        <label>Service for</label>
        <div class="input-group">
          <select v-model="data.service_for" class="form-control">
            <option value="">General</option>
            <option v-for="pdt in Products" :key="pdt.value" :value="pdt.id">{{ pdt.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-3" v-if="data.is_product == 0 && data.service_for != ''">
        <label>Rate</label>
        <div class="input-group">
          <input type="number" placeholder="Enter service rate" class="form-control" v-model="data.service_rate" />
        </div>
      </div>
      <div class="form-group mb-3" v-if="GeneralSettings.use_consumable_additives == 1">
        <label>Is Additive</label>
        <div class="input-group">
          <select class="form-control" v-model="data.is_additive">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Item Name</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Item Name" class="form-control" @input="resetError()"
            v-model="data.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3" v-if="data.is_product == 1">
        <label>Units</label>
        <div class="input-group">
          <input class="form-control" v-model="data.unit" list="units" @keyup=checkData()
            placeholder="Enter Product unit" autocomplete="off" />
          <datalist id="units">
            <option v-for="(cat, c) in Units" :data-value="cat.name" :key="c">
              {{ cat.symbol }}
            </option>
          </datalist>
        </div>
        <div class="text-danger" v-if="unitError">
          <em>{{ unitError }}</em>
        </div>
      </div>
      <div class="form-group mb-3" v-if="data.is_product == 1">
        <label>Quantity</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Quantity" class="form-control" @input="resetError()"
            v-model="data.quantity" />
        </div>
      </div>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6" v-if="data.is_product == 1">
          <label>Minimum Quantity</label>
          <div class="input-group">
            <input type="number" placeholder="Enter warning Quantity" class="form-control" @input="resetError()"
              v-model="data.minimum_quantity" />
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Cost Price</label>
          <div class="input-group">
            <input placeholder="Enter cost price" class="form-control" @input="resetError(), commaSeparator()"
              v-model="data.buying_price" />
          </div>
        </div> 
      </div>     
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled> <i class="fa fa-check"></i>
          Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addItem('add-item-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title> Edit Consumable {{ editdata.name }}</template>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a Product</label>
          <div class="input-group">
            <select v-model="editdata.is_product" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a final Product</label>
          <div class="input-group">
            <select v-model="editdata.is_final_product" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a Brand</label>
          <div class="input-group">
            <select v-model="editdata.is_brand" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Is it a base product</label>
          <div class="input-group">
            <select v-model="editdata.is_base" class="form-control">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>
      <div class="form-group mb-3" v-if="editdata.is_product == 0">
        <label>Service for</label>
        <div class="input-group">
          <select v-model="editdata.service_for" class="form-control">
            <option value="">General</option>
            <option v-for="pdt in Products" :key="pdt.value" :value="pdt.id">{{ pdt.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-3" v-if="editdata.is_product == 0 && editdata.service_for != ''">
        <label>Rate</label>
        <div class="input-group">
          <input type="number" placeholder="Enter service rate" class="form-control" v-model="editdata.service_rate" />
        </div>
      </div>
      <div class="form-group mb-3" v-if="GeneralSettings.use_consumable_additives == 1">
        <label>Is Additive</label>
        <div class="input-group">
          <select class="form-control" v-model="editdata.is_additive">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Item Name</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Item Name" class="form-control" @input="resetError()"
            v-model="editdata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3" v-if="editdata.is_product == 1">
        <label>Units</label>
        <div class="input-group">
          <model-list-select :list="Units ? Units : []" v-model="editdata.unit" option-value="id" option-text="name"
            @input="resetError()" placeholder="Select Units" @keyup="checkEditData()">
          </model-list-select>
        </div>
        <div class="text-danger" v-if="unitError">
          <em>{{ unitError }}</em>
        </div>
      </div>
      <div class="row">
        <div class="form-group mb-3 col-12 col-md-6" v-if="editdata.is_product == 1">
          <label>Minimum Quantity</label>
          <div class="input-group">
            <input type="number" placeholder="Enter warning Quantity" class="form-control" @input="resetError()"
              v-model="editdata.minimum_quantity" />
          </div>
        </div>
        <div class="form-group mb-3 col-12 col-md-6">
          <label>Cost Price</label>
          <div class="input-group">
            <input placeholder="Enter cost price" class="form-control" @input="resetError(), commaSeparator()"
              v-model="editdata.buying_price" />
          </div>
        </div> 
      </div>     
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('edit-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editItem('edit-item-modal')"> <i class="fa fa-check"></i>
          Submit
          <b-spinner v-if="SaveStatus" variant="light" small label="Spinning"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete category starts -->
    <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
      footer-bg-variant="danger" footer-text-variant="danger" id="delete-item-modal" hide-footer @hidden="resetDelete">
      <template #modal-title> Delete Consumable {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Consumable Item? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('delete-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteConsumables('delete-item-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
